export const UserIcon = () => {
  return (
    <svg
      width={18}
      height={18}
      viewBox="0 0 18 18"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.273 6.545a3.273 3.273 0 1 1-6.546 0 3.273 3.273 0 0 1 6.546 0Zm-1.637 0a1.636 1.636 0 1 1-3.272 0 1.636 1.636 0 0 1 3.272 0Z"
        fill="currentcolor"
      />

      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 0a9 9 0 1 0 0 18A9 9 0 0 0 9 0ZM1.636 9c0 1.71.583 3.284 1.561 4.534a7.352 7.352 0 0 1 5.856-2.898 7.35 7.35 0 0 1 5.802 2.83A7.364 7.364 0 1 0 1.636 9ZM9 16.364a7.333 7.333 0 0 1-4.641-1.647 5.72 5.72 0 0 1 4.694-2.444 5.72 5.72 0 0 1 4.655 2.39A7.334 7.334 0 0 1 9 16.363Z"
        fill="currentcolor"
      />
    </svg>
  );
};
